/**
 * URL pública de validação de documento clínico (`/r/:token`).
 * `VITE_PUBLIC_VALIDATOR_BASE_URL` opcional (ex.: subdomínio dedicado); caso contrário usa o origin atual.
 */
export const getPublicDocumentValidatorOrigin = (): string => {
  const fromEnv = (import.meta.env.VITE_PUBLIC_VALIDATOR_BASE_URL as string | undefined)?.trim()
  if (fromEnv) return fromEnv.replace(/\/$/, '')
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '')
  }
  return ''
}

export const buildPublicDocumentSharePath = (token: string): string => {
  const t = token.trim().toUpperCase()
  return `/r/${encodeURIComponent(t)}`
}

export const buildPublicDocumentShareUrl = (token: string): string => {
  const origin = getPublicDocumentValidatorOrigin()
  const path = buildPublicDocumentSharePath(token)
  return origin ? `${origin}${path}` : path
}
